import { catalog } from "../i18n.js";

/** The bot switcher (components/Switcher.tsx), opened with ⌘K or Ctrl+K. */
export const SWITCHER = catalog(
  {
    title: "Switch bot",
    search: "Jump to a bot…",
    nothing: (query: string) => `No bot matches “${query}”.`,
    noBots: "No bots yet.",
    working: "Working",
    needsYou: "Needs you",
    hidden: "Hidden",
    hint: "↑↓ to move · Enter to open · Esc to close",
  },
  {
    title: "Pindah bot",
    search: "Cari bot…",
    nothing: (query: string) => `Tidak ada bot yang cocok dengan “${query}”.`,
    noBots: "Belum ada bot.",
    working: "Bekerja",
    needsYou: "Menunggu kamu",
    hidden: "Tersembunyi",
    hint: "↑↓ untuk pindah · Enter untuk buka · Esc untuk tutup",
  },
);
